import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [],
  user: {
    email: "",
    password: "",
    repassword: "",
    name: "",
    lastName: "",
    identification: "",
    cellPhone: "",
    country: "",
    city: "",
    address: "",
    company: "",
    status: false,
    token: "",
    fullName: "",
    countryid: "",
    documenttypeid: "",
    chargeid: "",
    departmentid: "",
    organizationid: "",
    surname1: "",
    surname2: "",
    profile: "",
    temporalpassword: "",
    useLimit: "",
    legalDocument: "",
    autentikarId: "",
    uanatacaId: "",
    onboardingStatus: "",
    charge: {},
    department: {},
    country: {},
    documentType: {},
    organization: {},
    isIntern: false,
  },
  token: "",
  userValidation: {
    isValid: true,
    isUserInfoValid: false,
    isUserGeneralInfoValid: false,
    email: {
      isValid: true,
      errorMessage: "El formato del correo es incorrecto.",
    },
    name: {
      isValid: true,
      errorMessage: "El campo name no debe estar vacio",
    },
    address: {
      isValid: true,
      errorMessage: "El campo dirección no debe estar vacio",
    },
    lastName: {
      isValid: true,
      errorMessage: "El campo lastName no debe estar vacio",
    },
    identification: {
      isValid: true,
      errorMessage: "El campo identificación no es válido",
    },
    cellPhone: {
      isValid: true,
      errorMessage: "El campo celular no debe estar vacio",
    },
    country: {
      isValid: true,
      errorMessage: "Debe seleccionar un país",
    },
    password: {
      isValid: true,
      errorMessage: "Contraseña incorrecta",
    },
    repassword: {
      isValid: true,
      errorMessage: "Contraseña incorrecta",
    },
    countryid: {
      isValid: true,
      errorMessage: "Debe seleccionar un país",
    },
    city: {
      isValid: true,
      errorMessage: "Debe indicar una ciudad",
    },
    documenttypeid: {
      isValid: true,
      errorMessage: "Debe seleccionar un tipo de documento",
    },
    chargeid: {
      isValid: true,
      errorMessage: "Debe seleccionar un cargo",
    },
    departmentid: {
      isValid: true,
      errorMessage: "Debe seleccionar un departamento",
    },
    organizationid: {
      isValid: true,
      errorMessage: "Debe seleccionar una organización",
    },
    surname1: {
      isValid: true,
      errorMessage: "El campo primer apellido no debe estar vacio",
    },
    surname2: {
      isValid: true,
      errorMessage: "El campo segundo apellido no debe estar vacio",
    },
    profile: {
      isValid: true,
      errorMessage: "El campo perfil no debe estar vacio",
    },
    temporalpassword: {
      isValid: true,
      errorMessage: "El campo temporalpassword no debe estar vacio",
    },
    useLimit: {
      isValid: true,
      errorMessage: "El campo useLimit no debe estar vacio",
    },
    legalDocument: {
      isValid: true,
      errorMessage: "El campo legalDocument no debe estar vacio",
    },
    autentikarId: {
      isValid: true,
      errorMessage: "El campo autentikarId no debe estar vacio",
    },
    uanatacaId: {
      isValid: true,
      errorMessage: "El campo uanatacaId no debe estar vacio",
    },
    onboardingStatus: {
      isValid: true,
      errorMessage: "El campo onboardingStatus no debe estar vacio",
    },
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    restartState(state) {
      state.user = {};
      state.users = [];
    },
    setUsers(state, actions) {
      state.users = actions.payload.users;
    },
    setUser(state, actions) {
      state.user = actions.payload.user;
      state.users = [];
    },
    modifyPropertyValue(state, actions) {
      state.user[actions.payload.id] = actions.payload.value;
    },
    setUserValidation(state, actions) {
      state.userValidation = {
        name: {
          ...state.userValidation.name,
          isValid: actions.payload.name !== "",
        },
        surname1: {
          ...state.userValidation.surname1,
          isValid: actions.payload.surname1 !== "",
        },
        surname2: {
          ...state.userValidation.surname2,
          isValid: actions.payload.surname2 !== "",
        },
        identification: {
          ...state.userValidation.identification,
          isValid: actions.payload.identification !== "",
        },
        email: {
          ...state.userValidation.email,
          isValid: actions.payload.email !== "",
        },
        cellPhone: {
          ...state.userValidation.cellPhone,
          isValid: actions.payload.cellPhone !== "",
        },
        city: {
          ...state.userValidation.city,
          isValid: actions.payload.city !== "",
        },
        direction: {
          ...state.userValidation.direction,
          isValid: actions.payload.direction !== "",
        },
        chargeid: {
          ...state.userValidation.chargeid,
          isValid: actions.payload.chargeid !== "",
        },
        documenttypeid: {
          ...state.userValidation.documenttypeid,
          isValid: actions.payload.documenttypeid !== "",
        },
        organizationid: {
          ...state.userValidation.organizationid,
          isValid: actions.payload.organizationid !== "",
        },
        countryid: {
          ...state.userValidation.countryid,
          isValid: actions.payload.countryid !== "",
        },
      };
      state.userValidation.isValid =
        state.userValidation.description.isValid;
    },setUserValidation(state, actions) {
      state.userValidation = {
        name: {
          ...state.userValidation.name,
          isValid: actions.payload.name !== "",
        },
        lastName: {
          ...state.userValidation.lastName,
          isValid: actions.payload.lastName !== "",
        },
        identification: {
          ...state.userValidation.identification,
          isValid: actions.payload.identification !== "",
        },
        cellPhone: {
          ...state.userValidation.cellPhone,
          isValid: actions.payload.cellPhone !== "",
        },
        country: {
          ...state.userValidation.country,
          isValid: actions.payload.country !== "",
        },
        city: {
          ...state.userValidation.city,
          isValid: actions.payload.city !== "",
        },
        address: {
          ...state.userValidation.address,
          isValid: actions.payload.address !== "",
        },
        company: {
          ...state.userValidation.company,
          isValid: actions.payload.company !== "",
        },
        charge: {
          ...state.userValidation.charge,
          isValid: actions.payload.charge !== "",
        },
        department: {
          ...state.userValidation.department,
          isValid: actions.payload.department !== "",
        },
        countryid: {
          ...state.userValidation.countryid,
          isValid: actions.payload.countryid !== "",
        },
        status: {
          ...state.userValidation.status,
          isValid: actions.payload.status !== "",
        },
        token: {
          ...state.userValidation.token,
          isValid: actions.payload.token !== "",
        },
        fullName: {
          ...state.userValidation.fullName,
          isValid: actions.payload.fullName !== "",
        },
        ordens: {
          ...state.userValidation.ordens,
          isValid: actions.payload.ordens !== "",
        },
        documentType: {
          ...state.userValidation.documentType,
          isValid: actions.payload.documentType !== "",
        },
        organization: {
          ...state.userValidation.organization,
          isValid: actions.payload.organization !== "",
        },
        surname1: {
          ...state.userValidation.surname1,
          isValid: actions.payload.surname1 !== "",
        },
        surname2: {
          ...state.userValidation.surname2,
          isValid: actions.payload.surname2 !== "",
        },
        email: {
          ...state.userValidation.email,
          isValid: actions.payload.email !== "",
        },
        profile: {
          ...state.userValidation.profile,
          isValid: actions.payload.profile !== "",
        },
        password: {
          ...state.userValidation.password,
          isValid: actions.payload.password !== "",
        },
        temporalPassword: {
          ...state.userValidation.temporalPassword,
          isValid: actions.payload.temporalPassword !== "",
        },
        legalDocument: {
          ...state.userValidation.legalDocument,
          isValid: actions.payload.legalDocument !== "",
        },
        autentikarId: {
          ...state.userValidation.autentikarId,
          isValid: actions.payload.autentikarId !== "",
        },
        uanatacaId: {
          ...state.userValidation.uanatacaId,
          isValid: actions.payload.uanatacaId !== "",
        },
        onboardingStatus: {
          ...state.userValidation.onboardingStatus,
          isValid: actions.payload.onboardingStatus !== "",
        },
        useLimit: {
          ...state.userValidation.useLimit,
          isValid: actions.payload.useLimit !== "",
        },
        chargeid: {
          ...state.userValidation.chargeid,
          isValid: actions.payload.chargeid !== "",
        },
        organizationid: {
          ...state.userValidation.organizationid,
          isValid: actions.payload.organizationid !== "",
        },
        documenttypeid: {
          ...state.userValidation.documenttypeid,
          isValid: actions.payload.documenttypeid !== "",
        },
        departmentid: {
          ...state.userValidation.departmentid,
          isValid: actions.payload.departmentid !== "",
        }
      };
    
      state.userValidation.isValid = 
        state.userValidation.name.isValid &&
        state.userValidation.lastName.isValid &&
        state.userValidation.identification.isValid &&
        state.userValidation.email.isValid &&
        state.userValidation.cellPhone.isValid &&
        state.userValidation.country.isValid &&
        state.userValidation.city.isValid &&
        state.userValidation.address.isValid &&
        state.userValidation.company.isValid &&
        state.userValidation.chargeid.isValid &&
        state.userValidation.countryid.isValid &&
        state.userValidation.departmentid.isValid &&
        state.userValidation.status.isValid &&
        state.userValidation.token.isValid &&
        state.userValidation.fullName.isValid &&
        state.userValidation.ordens.isValid &&
        state.userValidation.documenttypeid.isValid &&
        state.userValidation.organizationid.isValid &&
        state.userValidation.surname1.isValid &&
        state.userValidation.surname2.isValid &&
        state.userValidation.email.isValid &&
        state.userValidation.profile.isValid &&
        state.userValidation.password.isValid &&
        state.userValidation.temporalPassword.isValid &&
        state.userValidation.useLimit.isValid &&
        state.userValidation.legalDocument.isValid &&
        state.userValidation.autentikarId.isValid &&
        state.userValidation.uanatacaId.isValid &&
        state.userValidation.onboardingStatus.isValid;

    
      state.userValidation.isUserInfoValid =
       state.userValidation.email.isValid &&
        state.userValidation.password.isValid &&
        state.userValidation.temporalPassword.isValid;
    
      state.userValidation.isUserGeneralInfoValid =
      state.userValidation.email.isValid &&
        state.userValidation.name.isValid &&
        state.userValidation.lastName.isValid &&
        state.userValidation.identification.isValid &&
        state.userValidation.cellPhone.isValid;
    },
    setFieldValid(state, actions) {
      state.userValidation[actions.payload.id].isValid = actions.payload.value;
    },
  },
});

export const userActions = userSlice.actions;
export default userSlice;
